(function () {
  'use strict';

  var CONTROL_SELECTOR = '[data-quantity-tier-control]';
  var PROXY_SELECT_SELECTOR = '[data-quantity-tier-select]';
  var DROPDOWN_GROUP_SELECTOR = '.qty-tier-control__dropdown-group';
  var NATIVE_SELECT_WRAPPER_SELECTOR = '.select';
  var RICH_DROPDOWN_SELECTOR = '[data-qty-tier-rich-dropdown]';
  var RICH_TRIGGER_SELECTOR = '[data-qty-tier-rich-trigger]';
  var RICH_OPTION_SELECTOR = '[data-qty-tier-rich-option]';
  var ORIGINAL_SELECT_SELECTOR = 'select[name="options[Quantity]"]';
  var PACKAGING_SELECT_SELECTOR = 'select[name="options[Packaging]"]';
  var OPTION_SELECT_SELECTOR = 'select[name^="options["]';
  var QTY_INPUT_SELECTOR = '.qty-input';
  var PLUS_SELECTOR = '.qty-btn.plus';
  var MINUS_SELECTOR = '.qty-btn.minus';
  var UNAVAILABLE_RE = /unavailable/i;
  var SAMPLE_DECK_RE = /sample\s*deck/i;

  var instances = [];

  function asArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function createElement(tag, className) {
    var node = document.createElement(tag);
    if (className) {
      node.className = className;
    }
    return node;
  }

  function parseInteger(value) {
    if (value === null || value === undefined) return null;
    var normalized = String(value).replace(/,/g, '').replace(/[^\d-]/g, '');
    if (!normalized) return null;
    var parsed = parseInt(normalized, 10);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function formatWholeNumber(value) {
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value);
  }

  function formatCurrency(value, code) {
    var currency = code || 'USD';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(2);
    }
  }

  function parseJsonScript(control, selector) {
    var script = control.querySelector(selector);
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || 'null');
    } catch (error) {
      return null;
    }
  }

  function parseQuantityFromOption(option) {
    if (!option) return null;

    if (!option.dataset.qtyTierOriginalText) {
      option.dataset.qtyTierOriginalText = (option.textContent || '').trim();
    }

    var quantity = parseInteger(option.value);
    if (quantity !== null && quantity > 0) return quantity;

    var originalText = option.dataset.qtyTierOriginalText || '';
    var match = originalText.replace(/,/g, '').match(/\d+/);
    if (!match) return null;

    var parsed = parseInt(match[0], 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function optionNameFromSelect(select) {
    if (!select || !select.name) return null;
    var match = select.name.match(/^options\[(.*)\]$/);
    return match ? match[1] : null;
  }

  function cleanupInstances() {
    instances = instances.filter(function (instance) {
      return instance.control && instance.control.isConnected;
    });
  }

  function findInstanceByControl(control) {
    cleanupInstances();
    for (var i = 0; i < instances.length; i += 1) {
      if (instances[i].control === control) return instances[i];
    }
    return null;
  }

  function findInstanceByFormId(formId) {
    cleanupInstances();
    if (!formId) return null;
    for (var i = 0; i < instances.length; i += 1) {
      if (instances[i].formId === formId) return instances[i];
    }
    return null;
  }

  function findNearestEnabledIndex(options, startIndex, step) {
    var index = startIndex + step;
    while (index >= 0 && index < options.length) {
      if (!options[index].disabled) return index;
      index += step;
    }
    return -1;
  }

  function resolveOriginalSelect(instance) {
    var scope = instance.scopeRoot || document;
    var selects = asArray(scope.querySelectorAll(ORIGINAL_SELECT_SELECTOR));

    if (instance.formId) {
      selects = selects.filter(function (select) {
        return select.getAttribute('form') === instance.formId;
      });
    }

    if (!selects.length) {
      selects = asArray(document.querySelectorAll(ORIGINAL_SELECT_SELECTOR));
      if (instance.formId) {
        selects = selects.filter(function (select) {
          return select.getAttribute('form') === instance.formId;
        });
      }
    }

    return selects.length ? selects[0] : null;
  }

  function resolvePackagingSelect(instance) {
    var scope = instance.scopeRoot || document;
    var selects = asArray(scope.querySelectorAll(PACKAGING_SELECT_SELECTOR));

    if (instance.formId) {
      selects = selects.filter(function (select) {
        return select.getAttribute('form') === instance.formId;
      });
    }

    if (!selects.length) {
      selects = asArray(document.querySelectorAll(PACKAGING_SELECT_SELECTOR));
      if (instance.formId) {
        selects = selects.filter(function (select) {
          return select.getAttribute('form') === instance.formId;
        });
      }
    }

    return selects.length ? selects[0] : null;
  }

  function isSampleDeckSelected(packagingSelect) {
    if (!packagingSelect) return false;
    var selectedOption = packagingSelect.options[packagingSelect.selectedIndex];
    if (!selectedOption) return false;

    var text = (selectedOption.textContent || '').trim();
    var value = String(selectedOption.value || '');
    return SAMPLE_DECK_RE.test(text) || SAMPLE_DECK_RE.test(value);
  }

  function forceQuantityOneForSamplePackaging(instance) {
    if (!instance || !instance.proxySelect) return false;

    var quantityIndex = -1;
    for (var i = 0; i < instance.proxySelect.options.length; i += 1) {
      var option = instance.proxySelect.options[i];
      if (parseQuantityFromOption(option) === 1) {
        quantityIndex = i;
        break;
      }
    }

    if (quantityIndex === -1 || instance.proxySelect.selectedIndex === quantityIndex) {
      return false;
    }

    selectProxyIndex(instance, quantityIndex, true);
    return true;
  }

  function normalizeToStep(value, step, minimum) {
    var numericStep = Number.isFinite(step) && step > 0 ? step : 25;
    var minValue = Number.isFinite(minimum) && minimum > 0 ? minimum : numericStep;

    if (!Number.isFinite(value)) return minValue;
    var bounded = Math.max(minValue, value);
    return Math.ceil(bounded / numericStep) * numericStep;
  }

  function getSelectableTierEntries(instance, minimumQty) {
    if (!instance || !instance.proxySelect) return [];

    var minQty = Number.isFinite(minimumQty) ? minimumQty : 25;
    return asArray(instance.proxySelect.options)
      .map(function (option, index) {
        return {
          index: index,
          disabled: option.disabled,
          qty: parseQuantityFromOption(option),
        };
      })
      .filter(function (entry) {
        return !entry.disabled && entry.qty !== null && entry.qty >= minQty;
      });
  }

  function findTierIndexForTarget(instance, targetQty, direction, minimumQty) {
    var entries = getSelectableTierEntries(instance, minimumQty);
    if (!entries.length) return -1;

    var step = instance && Number.isFinite(instance.quantityStep) ? instance.quantityStep : 25;
    var minQty = Number.isFinite(minimumQty) ? minimumQty : 25;
    var normalizedTarget = normalizeToStep(targetQty, step, minQty);

    if (direction === 'down') {
      for (var downIndex = entries.length - 1; downIndex >= 0; downIndex -= 1) {
        if (entries[downIndex].qty <= normalizedTarget) {
          return entries[downIndex].index;
        }
      }
      return entries[0].index;
    }

    for (var upIndex = 0; upIndex < entries.length; upIndex += 1) {
      if (entries[upIndex].qty >= normalizedTarget) {
        return entries[upIndex].index;
      }
    }

    return entries[entries.length - 1].index;
  }


  function collectSelectedOptionValues(instance) {
    var selectedByName = {};
    var scope = instance.scopeRoot || document;
    var selects = asArray(scope.querySelectorAll(OPTION_SELECT_SELECTOR));

    if (instance.formId) {
      selects = selects.filter(function (select) {
        return select.getAttribute('form') === instance.formId;
      });
    }

    selects.forEach(function (select) {
      var optionName = optionNameFromSelect(select);
      if (!optionName) return;
      selectedByName[optionName] = String(select.value);
    });

    return selectedByName;
  }

  function toOptionIgnoreMap(ignoredOptionNames) {
    if (!ignoredOptionNames) return null;

    var names = Array.isArray(ignoredOptionNames) ? ignoredOptionNames : [ignoredOptionNames];
    var map = {};
    names.forEach(function (name) {
      if (!name) return;
      map[String(name)] = true;
    });

    return Object.keys(map).length ? map : null;
  }

  function findMatchingVariant(instance, selectedByName, ignoredOptionNames, requireAvailable) {
    if (!instance.variants.length || !instance.optionNames.length) return null;

    var ignoredMap = toOptionIgnoreMap(ignoredOptionNames);

    for (var i = 0; i < instance.variants.length; i += 1) {
      var variant = instance.variants[i];
      if (!variant || !Array.isArray(variant.options) || variant.options.length !== instance.optionNames.length) {
        continue;
      }

      if (requireAvailable && variant.available === false) {
        continue;
      }

      var isMatch = true;
      for (var optionIndex = 0; optionIndex < instance.optionNames.length; optionIndex += 1) {
        var optionName = instance.optionNames[optionIndex];
        if (ignoredMap && ignoredMap[optionName]) {
          continue;
        }

        var selectedValue = selectedByName[optionName];
        if (selectedValue === undefined) {
          continue;
        }

        if (String(variant.options[optionIndex]) !== String(selectedValue)) {
          isMatch = false;
          break;
        }
      }

      if (isMatch) {
        return variant;
      }
    }

    return null;
  }

  function findVariantByQuantityOnly(instance, quantityValue, requireAvailable) {
    if (!instance.variants.length || !instance.optionNames.length) return null;

    var quantityIndex = instance.optionNames.indexOf('Quantity');
    if (quantityIndex === -1) return null;

    var desiredQty = String(quantityValue);

    for (var i = 0; i < instance.variants.length; i += 1) {
      var variant = instance.variants[i];
      if (!variant || !Array.isArray(variant.options) || variant.options.length !== instance.optionNames.length) {
        continue;
      }

      if (String(variant.options[quantityIndex]) !== desiredQty) {
        continue;
      }

      if (requireAvailable && variant.available === false) {
        continue;
      }

      return variant;
    }

    return null;
  }

  function findVariantByQuantityWithPackagingPreference(instance, quantityValue, requireAvailable, preferNonSamplePackaging) {
    if (!instance.variants.length || !instance.optionNames.length) return null;

    var quantityIndex = instance.optionNames.indexOf('Quantity');
    if (quantityIndex === -1) return null;

    var packagingIndex = instance.optionNames.indexOf('Packaging');
    var desiredQty = String(quantityValue);
    var fallback = null;

    for (var i = 0; i < instance.variants.length; i += 1) {
      var variant = instance.variants[i];
      if (!variant || !Array.isArray(variant.options) || variant.options.length !== instance.optionNames.length) {
        continue;
      }

      if (String(variant.options[quantityIndex]) !== desiredQty) {
        continue;
      }

      if (requireAvailable && variant.available === false) {
        continue;
      }

      if (preferNonSamplePackaging && packagingIndex !== -1) {
        var packagingValue = String(variant.options[packagingIndex] || '');
        if (!SAMPLE_DECK_RE.test(packagingValue)) {
          return variant;
        }
      }

      if (!fallback) {
        fallback = variant;
      }
    }

    return fallback;
  }

  function findPackagingFallbackVariant(instance, selectedByName, requireAvailable, avoidSamplePackaging) {
    if (!instance.variants.length || !instance.optionNames.length) return null;

    var packagingIndex = instance.optionNames.indexOf('Packaging');
    if (packagingIndex === -1) return null;

    for (var i = 0; i < instance.variants.length; i += 1) {
      var variant = instance.variants[i];
      if (!variant || !Array.isArray(variant.options) || variant.options.length !== instance.optionNames.length) {
        continue;
      }

      if (requireAvailable && variant.available === false) {
        continue;
      }

      if (avoidSamplePackaging && SAMPLE_DECK_RE.test(String(variant.options[packagingIndex] || ''))) {
        continue;
      }

      var isMatch = true;
      for (var optionIndex = 0; optionIndex < instance.optionNames.length; optionIndex += 1) {
        if (optionIndex === packagingIndex) {
          continue;
        }

        var optionName = instance.optionNames[optionIndex];
        var selectedValue = selectedByName[optionName];
        if (selectedValue === undefined) {
          continue;
        }

        if (String(variant.options[optionIndex]) !== String(selectedValue)) {
          isMatch = false;
          break;
        }
      }

      if (isMatch) {
        return variant;
      }
    }

    return null;
  }

  function applyVariantOptionsToNativeSelects(instance, variant) {
    if (!instance || !variant || !Array.isArray(variant.options) || !instance.optionNames.length) {
      return false;
    }

    var scope = instance.scopeRoot || document;
    var selects = asArray(scope.querySelectorAll(OPTION_SELECT_SELECTOR));
    if (instance.formId) {
      selects = selects.filter(function (select) {
        return select.getAttribute('form') === instance.formId;
      });
    }

    var changed = false;

    selects.forEach(function (select) {
      var optionName = optionNameFromSelect(select);
      if (!optionName) return;

      var optionIndex = instance.optionNames.indexOf(optionName);
      if (optionIndex === -1) return;

      var variantValue = variant.options[optionIndex];
      if (variantValue === undefined || variantValue === null) return;

      var normalizedValue = String(variantValue);
      if (String(select.value) !== normalizedValue) {
        select.value = normalizedValue;
        changed = true;
      }
    });

    return changed;
  }

  function escapeSamplePackagingForRegularQuantity(instance) {
    if (!instance || !instance.proxySelect) return false;

    var desiredQty = parseInteger(instance.proxySelect.value);
    if (!Number.isFinite(desiredQty) || desiredQty <= 1) return false;

    instance.packagingSelect = resolvePackagingSelect(instance);
    if (!instance.packagingSelect || !isSampleDeckSelected(instance.packagingSelect)) {
      return false;
    }

    var nonSampleOption = asArray(instance.packagingSelect.options).find(function (option) {
      var text = String(option.textContent || '');
      var value = String(option.value || '');
      return !SAMPLE_DECK_RE.test(text) && !SAMPLE_DECK_RE.test(value);
    });

    if (!nonSampleOption) return false;

    var nextPackagingValue = String(nonSampleOption.value);
    if (String(instance.packagingSelect.value) === nextPackagingValue) {
      return false;
    }

    instance.packagingSelect.value = nextPackagingValue;
    instance.packagingSelect.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function scheduleSamplePackagingEscape(instance) {
    if (!instance) return;

    escapeSamplePackagingForRegularQuantity(instance);

    [0, 120, 400, 900, 1500].forEach(function (delay) {
      window.setTimeout(function () {
        if (!instance.control || !instance.control.isConnected) return;
        escapeSamplePackagingForRegularQuantity(instance);
      }, delay);
    });
  }

  function findVariantForQuantity(instance, quantityValue) {
    if (!instance.variants.length || !instance.optionNames.length) return null;

    var selectedByName = collectSelectedOptionValues(instance);
    selectedByName.Quantity = String(quantityValue);

    var hasPackagingOption = instance.optionNames.indexOf('Packaging') !== -1;
    instance.packagingSelect = resolvePackagingSelect(instance);
    var samplePackagingSelected = hasPackagingOption && isSampleDeckSelected(instance.packagingSelect);
    var numericQty = parseInteger(quantityValue);
    var forcePackagingFallback = samplePackagingSelected && Number.isFinite(numericQty) && numericQty > 1;

    if (forcePackagingFallback && hasPackagingOption) {
      var nonSampleAvailable = findPackagingFallbackVariant(instance, selectedByName, true, true);
      if (nonSampleAvailable) return nonSampleAvailable;

      var nonSampleAny = findPackagingFallbackVariant(instance, selectedByName, false, true);
      if (nonSampleAny) return nonSampleAny;

      var qtyPreferredAvailable = findVariantByQuantityWithPackagingPreference(instance, quantityValue, true, true);
      if (qtyPreferredAvailable) return qtyPreferredAvailable;

      var qtyPreferredAny = findVariantByQuantityWithPackagingPreference(instance, quantityValue, false, true);
      if (qtyPreferredAny) return qtyPreferredAny;
    }

    if (!forcePackagingFallback) {
      var exactAvailable = findMatchingVariant(instance, selectedByName, null, true);
      if (exactAvailable) return exactAvailable;
    }

    if (hasPackagingOption) {
      var packagingFlexibleAvailable = findMatchingVariant(instance, selectedByName, 'Packaging', true);
      if (packagingFlexibleAvailable) return packagingFlexibleAvailable;
    }

    if (!forcePackagingFallback) {
      var exactAny = findMatchingVariant(instance, selectedByName, null, false);
      if (exactAny) return exactAny;
    }

    if (hasPackagingOption) {
      var packagingFlexibleAny = findMatchingVariant(instance, selectedByName, 'Packaging', false);
      if (packagingFlexibleAny) return packagingFlexibleAny;
    }

    return findVariantByQuantityOnly(instance, quantityValue, true) ||
      findVariantByQuantityOnly(instance, quantityValue, false);
  }

  function getPerDeckPrice(variant, quantityValue) {
    if (!variant || typeof variant.price !== 'number') return null;
    if (!Number.isFinite(quantityValue) || quantityValue <= 0) return null;

    var perDeck = variant.price / 100 / quantityValue;
    return Number.isFinite(perDeck) ? perDeck : null;
  }

  function computeMaxPerDeckPrice(instance, sourceOptions, canResolveVariant) {
    if (!canResolveVariant) return null;

    var maxPerDeck = null;

    sourceOptions.forEach(function (sourceOption) {
      var quantityValue = parseQuantityFromOption(sourceOption);
      if (quantityValue === null) return;

      var variant = findVariantForQuantity(instance, sourceOption.value);
      var perDeckPrice = getPerDeckPrice(variant, quantityValue);
      if (perDeckPrice === null) return;

      if (maxPerDeck === null || perDeckPrice > maxPerDeck) {
        maxPerDeck = perDeckPrice;
      }
    });

    return maxPerDeck;
  }

  function buildOptionPresentation(instance, sourceOption, quantityValue, variant, isUnavailable, maxPerDeckPrice) {
    var originalText = sourceOption.dataset.qtyTierOriginalText || (sourceOption.textContent || '').trim();
    var cleanText = originalText.replace(/\s*-\s*Unavailable\s*$/i, '').trim();

    var qtyLabel = quantityValue !== null
      ? formatWholeNumber(quantityValue) + ' ' + (quantityValue === 1 ? 'deck' : 'decks')
      : cleanText || originalText;
    var oldPriceText = null;
    var newPriceText = null;
    var fallbackText = null;

    if (quantityValue !== null) {
      if (variant && typeof variant.price === 'number' && quantityValue > 0) {
        var currentPerDeck = getPerDeckPrice(variant, quantityValue);
        if (currentPerDeck !== null) {
          newPriceText = formatCurrency(currentPerDeck, instance.currencyCode);
          if (typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price) {
            var comparePerDeck = variant.compare_at_price / 100 / quantityValue;
            if (Number.isFinite(comparePerDeck) && comparePerDeck > currentPerDeck + 0.000001) {
              oldPriceText = formatCurrency(comparePerDeck, instance.currencyCode);
            }
          }
          if (!oldPriceText && maxPerDeckPrice !== null && maxPerDeckPrice - currentPerDeck > 0.000001) {
            oldPriceText = formatCurrency(maxPerDeckPrice, instance.currencyCode);
          }
        } else {
          fallbackText = cleanText;
        }
      } else if (cleanText && cleanText !== String(quantityValue)) {
        fallbackText = cleanText;
      }
    }

    var label = qtyLabel;
    if (newPriceText && oldPriceText) {
      label += ' @ (' + oldPriceText + ') ' + newPriceText + ' /deck';
    } else if (newPriceText) {
      label += ' @ ' + newPriceText + ' /deck';
    } else if (fallbackText) {
      label += ' @ ' + fallbackText;
    }

    if (isUnavailable) {
      label += ' - Unavailable';
    }

    return {
      value: String(sourceOption.value),
      qtyLabel: qtyLabel,
      oldPriceText: oldPriceText,
      newPriceText: newPriceText,
      fallbackText: fallbackText,
      isUnavailable: Boolean(isUnavailable),
      label: label,
    };
  }

  function buildProxyOptionLabel(presentation) {
    return presentation.label;
  }

  function rebuildProxyOptions(instance) {
    if (!instance.proxySelect || !instance.originalSelect) return;

    var sourceOptions = asArray(instance.originalSelect.options);
    var selectedValue = String(instance.originalSelect.value);
    var canResolveVariant = instance.variants.length > 0 && instance.optionNames.length > 0;
    var maxPerDeckPrice = computeMaxPerDeckPrice(instance, sourceOptions, canResolveVariant);

    instance.proxySelect.innerHTML = '';
    instance.optionPresentationByValue = {};

    sourceOptions.forEach(function (sourceOption) {
      var quantityValue = parseQuantityFromOption(sourceOption);
      var variant = quantityValue !== null && canResolveVariant ? findVariantForQuantity(instance, sourceOption.value) : null;

      var textUnavailable = !variant && UNAVAILABLE_RE.test(sourceOption.dataset.qtyTierOriginalText || sourceOption.textContent || '');
      var variantUnavailable = canResolveVariant && variant ? variant.available === false : false;
      var isUnavailable = Boolean(textUnavailable || variantUnavailable);

      var proxyOption = document.createElement('option');
      proxyOption.value = sourceOption.value;
      var presentation = buildOptionPresentation(
        instance,
        sourceOption,
        quantityValue,
        variant,
        isUnavailable,
        maxPerDeckPrice
      );
      proxyOption.textContent = buildProxyOptionLabel(presentation);
      proxyOption.disabled = !String(sourceOption.value || '').trim();
      proxyOption.selected = String(sourceOption.value) === selectedValue;

      instance.optionPresentationByValue[String(proxyOption.value)] = presentation;

      instance.proxySelect.appendChild(proxyOption);
    });

    if (!instance.proxySelect.value && instance.proxySelect.options.length) {
      instance.proxySelect.selectedIndex = 0;
    }
  }

  function getPresentationForOption(instance, option) {
    if (!instance || !option) return null;
    var key = String(option.value);
    return instance.optionPresentationByValue ? instance.optionPresentationByValue[key] : null;
  }

  function renderRichPriceValue(container, presentation) {
    container.innerHTML = '';

    var qty = createElement('span', 'qty-tier-rich-dropdown__qty');
    qty.textContent = presentation.qtyLabel;
    container.appendChild(qty);

    var hasPriceOrFallback =
      (presentation.oldPriceText && presentation.newPriceText) ||
      presentation.newPriceText ||
      presentation.fallbackText;

    if (hasPriceOrFallback) {
      var at = createElement('span', 'qty-tier-rich-dropdown__at');
      at.textContent = '@';
      container.appendChild(at);
    }

    if (presentation.oldPriceText && presentation.newPriceText) {
      var prices = createElement('span', 'qty-tier-rich-dropdown__prices');

      var oldWrap = createElement('span', 'qty-tier-rich-dropdown__price-old-wrap');
      oldWrap.appendChild(document.createTextNode('('));
      var oldValue = createElement('span', 'qty-tier-rich-dropdown__price-old');
      oldValue.textContent = presentation.oldPriceText;
      oldWrap.appendChild(oldValue);
      oldWrap.appendChild(document.createTextNode(')'));
      prices.appendChild(oldWrap);

      var newPrice = createElement('span', 'qty-tier-rich-dropdown__price-new');
      var newValue = createElement('span', 'qty-tier-rich-dropdown__price-new-value');
      newValue.textContent = presentation.newPriceText;
      var unit = createElement('span', 'qty-tier-rich-dropdown__unit');
      unit.textContent = '/deck';
      newPrice.appendChild(newValue);
      newPrice.appendChild(unit);
      prices.appendChild(newPrice);

      container.appendChild(prices);
    } else if (presentation.newPriceText) {
      var singleNew = createElement('span', 'qty-tier-rich-dropdown__price-new');
      var singleNewValue = createElement('span', 'qty-tier-rich-dropdown__price-new-value');
      singleNewValue.textContent = presentation.newPriceText;
      var singleUnit = createElement('span', 'qty-tier-rich-dropdown__unit');
      singleUnit.textContent = '/deck';
      singleNew.appendChild(singleNewValue);
      singleNew.appendChild(singleUnit);
      container.appendChild(singleNew);
    } else if (presentation.fallbackText) {
      var fallback = createElement('span', 'qty-tier-rich-dropdown__fallback');
      fallback.textContent = presentation.fallbackText;
      container.appendChild(fallback);
    }

    if (presentation.isUnavailable) {
      var unavailable = createElement('span', 'qty-tier-rich-dropdown__unavailable');
      unavailable.textContent = 'Unavailable';
      container.appendChild(unavailable);
    }
  }

  function ensureRichDropdown(instance) {
    if (!instance || instance.mode !== 'tier') return;
    if (!instance.proxySelect) return;

    var dropdownGroup = instance.control.querySelector(DROPDOWN_GROUP_SELECTOR);
    if (!dropdownGroup) return;

    var nativeWrapper = dropdownGroup.querySelector(NATIVE_SELECT_WRAPPER_SELECTOR);
    if (!nativeWrapper) return;

    if (instance.richDropdown && instance.richDropdown.root && instance.richDropdown.root.isConnected) {
      return;
    }

    var root = createElement('div', 'qty-tier-rich-dropdown');
    root.setAttribute('data-qty-tier-rich-dropdown', '');

    var trigger = createElement('button', 'qty-tier-rich-dropdown__trigger');
    trigger.type = 'button';
    trigger.setAttribute('data-qty-tier-rich-trigger', '');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerValue = createElement('span', 'qty-tier-rich-dropdown__trigger-value');
    trigger.appendChild(triggerValue);

    var triggerCaret = createElement('span', 'qty-tier-rich-dropdown__caret');
    triggerCaret.setAttribute('aria-hidden', 'true');
    triggerCaret.textContent = '▾';
    trigger.appendChild(triggerCaret);

    var menu = createElement('div', 'qty-tier-rich-dropdown__menu');
    menu.setAttribute('data-qty-tier-rich-menu', '');
    menu.hidden = true;

    var list = createElement('ul', 'qty-tier-rich-dropdown__list');
    list.setAttribute('role', 'listbox');
    menu.appendChild(list);

    root.appendChild(trigger);
    root.appendChild(menu);

    nativeWrapper.classList.add('qty-tier-select-native');
    nativeWrapper.insertAdjacentElement('afterend', root);

    instance.richDropdown = {
      root: root,
      trigger: trigger,
      triggerValue: triggerValue,
      menu: menu,
      list: list,
    };
  }

  function renderRichDropdownOptions(instance) {
    if (!instance || !instance.richDropdown || !instance.proxySelect) return;

    var rich = instance.richDropdown;
    var options = asArray(instance.proxySelect.options);
    var selectedValue = String(instance.proxySelect.value);

    rich.list.innerHTML = '';

    options.forEach(function (option) {
      var presentation = getPresentationForOption(instance, option);
      if (!presentation) return;

      var item = createElement('li', 'qty-tier-rich-dropdown__item');
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', String(option.value) === selectedValue ? 'true' : 'false');

      var itemButton = createElement('button', 'qty-tier-rich-dropdown__option');
      itemButton.type = 'button';
      itemButton.setAttribute('data-qty-tier-rich-option', '');
      itemButton.setAttribute('data-value', String(option.value));
      if (option.disabled) {
        itemButton.disabled = true;
      }
      if (String(option.value) === selectedValue) {
        itemButton.classList.add('is-selected');
      }

      renderRichPriceValue(itemButton, presentation);
      item.appendChild(itemButton);
      rich.list.appendChild(item);
    });
  }

  function syncRichDropdownState(instance) {
    if (!instance || !instance.richDropdown || !instance.proxySelect) return;

    var rich = instance.richDropdown;
    var selectedOption = instance.proxySelect.options[instance.proxySelect.selectedIndex];
    var presentation = getPresentationForOption(instance, selectedOption);

    if (presentation) {
      renderRichPriceValue(rich.triggerValue, presentation);
    } else {
      rich.triggerValue.textContent = selectedOption ? selectedOption.textContent : '';
    }

    var isDisabled = instance.proxySelect.disabled || !instance.proxySelect.options.length;
    rich.trigger.disabled = Boolean(isDisabled);
  }

  function closeRichDropdown(instance) {
    if (!instance || !instance.richDropdown) return;
    instance.richDropdown.menu.hidden = true;
    instance.richDropdown.trigger.setAttribute('aria-expanded', 'false');
    instance.richDropdown.root.classList.remove('is-open');
  }

  function closeAllRichDropdowns(exceptInstance) {
    instances.forEach(function (instance) {
      if (exceptInstance && exceptInstance === instance) return;
      closeRichDropdown(instance);
    });
  }

  function toggleRichDropdown(instance) {
    if (!instance || !instance.richDropdown) return;

    var isOpen = !instance.richDropdown.menu.hidden;
    if (isOpen) {
      closeRichDropdown(instance);
      return;
    }

    closeAllRichDropdowns(instance);
    instance.richDropdown.menu.hidden = false;
    instance.richDropdown.trigger.setAttribute('aria-expanded', 'true');
    instance.richDropdown.root.classList.add('is-open');
  }

  function refreshRichDropdown(instance) {
    if (!instance || instance.mode !== 'tier') return;

    ensureRichDropdown(instance);
    if (!instance.richDropdown) return;

    renderRichDropdownOptions(instance);
    syncRichDropdownState(instance);
    closeRichDropdown(instance);

    instance.control.classList.add('qty-tier-control--rich-ready');
  }

  function applyPackagingQuantityLock(instance) {
    if (!instance || instance.mode !== 'tier' || !instance.proxySelect) return;

    instance.packagingSelect = resolvePackagingSelect(instance);
    instance.quantityLockedByPackaging = isSampleDeckSelected(instance.packagingSelect);

    if (instance.quantityLockedByPackaging) {
      closeRichDropdown(instance);
    }

    // Quantity dropdown is the variant selector: keep it enabled even in sample mode.
    instance.proxySelect.disabled = Boolean(!instance.proxySelect.options.length);

    if (instance.input) {
      instance.input.disabled = Boolean(instance.quantityLockedByPackaging);
      if (instance.quantityLockedByPackaging) {
        instance.input.setAttribute('aria-disabled', 'true');
      } else {
        instance.input.removeAttribute('aria-disabled');
      }
    }

    syncInputFromProxy(instance);
    updateButtons(instance);
    syncRichDropdownState(instance);
    renderRichDropdownOptions(instance);
  }

  function syncInputFromProxy(instance) {
    if (!instance.input || !instance.proxySelect) return;

    var selectedOption = instance.proxySelect.options[instance.proxySelect.selectedIndex];
    var quantityValue = parseQuantityFromOption(selectedOption);

    if (quantityValue !== null) {
      instance.input.value = String(quantityValue);
    } else if (!instance.proxySelect.options.length) {
      instance.input.value = '';
    }
  }

  function updateButtons(instance) {
    if (!instance.plusButton || !instance.minusButton) return;

    if (instance.quantityLockedByPackaging) {
      instance.minusButton.disabled = true;
      instance.plusButton.disabled = true;
      return;
    }

    if (instance.mode === 'stock') {
      var value = parseInteger(instance.input.value);
      if (value === null) value = instance.stockMin;
      instance.minusButton.disabled = value <= instance.stockMin;
      instance.plusButton.disabled = value >= instance.stockMax;
      return;
    }

    if (!instance.proxySelect || !instance.proxySelect.options.length) {
      instance.plusButton.disabled = true;
      instance.minusButton.disabled = true;
      return;
    }

    var options = asArray(instance.proxySelect.options);
    var currentIndex = instance.proxySelect.selectedIndex;

    if (currentIndex < 0) {
      currentIndex = 0;
    }

    var prevIndex = findNearestEnabledIndex(options, currentIndex, -1);
    var nextIndex = findNearestEnabledIndex(options, currentIndex, 1);

    instance.minusButton.disabled = prevIndex === -1;
    instance.plusButton.disabled = nextIndex === -1;
  }

  function syncOriginalFromProxy(instance) {
    if (!instance.proxySelect) return;

    instance.originalSelect = resolveOriginalSelect(instance);
    if (!instance.originalSelect) return;

    var desiredValue = String(instance.proxySelect.value);
    var resolvedVariant = findVariantForQuantity(instance, desiredValue);
    var nativeChanged = resolvedVariant
      ? applyVariantOptionsToNativeSelects(instance, resolvedVariant)
      : false;

    if (!resolvedVariant && String(instance.originalSelect.value) !== desiredValue) {
      instance.originalSelect.value = desiredValue;
      nativeChanged = true;
    }

    if (nativeChanged) {
      instance.originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
      scheduleSamplePackagingEscape(instance);
    }

    syncInputFromProxy(instance);
    updateButtons(instance);
    syncRichDropdownState(instance);
    renderRichDropdownOptions(instance);
  }

  function selectProxyIndex(instance, index, triggerChange) {
    if (!instance.proxySelect) return;
    if (index < 0 || index >= instance.proxySelect.options.length) return;

    instance.proxySelect.selectedIndex = index;

    if (triggerChange) {
      instance.proxySelect.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      syncInputFromProxy(instance);
      updateButtons(instance);
    }
  }

  function sanitizeInputValue(input) {
    var raw = input.value || '';
    var sanitized = raw.replace(/[^\d]/g, '');
    input.value = sanitized;
  }

  function refreshTierInstance(instance) {
    instance.originalSelect = resolveOriginalSelect(instance);
    if (instance.scopeRoot && instance.scopeRoot.classList) {
      instance.scopeRoot.classList.add('quantity-tier-mounted');
    }

    if (!instance.originalSelect) {
      if (instance.proxySelect) {
        instance.proxySelect.innerHTML = '';
        instance.proxySelect.disabled = true;
      }
      closeRichDropdown(instance);
      if (instance.input) instance.input.value = '';
      if (instance.plusButton) instance.plusButton.disabled = true;
      if (instance.minusButton) instance.minusButton.disabled = true;
      return;
    }

    if (!instance.formId) {
      instance.formId = instance.originalSelect.getAttribute('form') || '';
    }

    instance.proxySelect.disabled = false;
    rebuildProxyOptions(instance);
    syncInputFromProxy(instance);
    refreshRichDropdown(instance);
    applyPackagingQuantityLock(instance);
    scheduleSamplePackagingEscape(instance);
    instance.control.classList.add('qty-tier-control--ready');
  }

  function clampStockQuantity(instance, qty) {
    if (!Number.isFinite(qty)) return instance.stockMin;
    if (qty < instance.stockMin) return instance.stockMin;
    if (qty > instance.stockMax) return instance.stockMax;
    return qty;
  }

  function refreshStockInstance(instance) {
    var current = parseInteger(instance.input.value);
    var clamped = clampStockQuantity(instance, current === null ? instance.stockMin : current);
    instance.input.value = String(clamped);
    updateButtons(instance);
  }

  function createInstance(control) {
    var mode = control.getAttribute('data-mode') || 'tier';
    var scopeRoot = control.closest('product-info') || document;

    var instance = {
      control: control,
      mode: mode,
      scopeRoot: scopeRoot,
      formId: control.getAttribute('data-product-form-id') || '',
      currencyCode: control.getAttribute('data-currency-code') || 'USD',
      input: control.querySelector(QTY_INPUT_SELECTOR),
      plusButton: control.querySelector(PLUS_SELECTOR),
      minusButton: control.querySelector(MINUS_SELECTOR),
      proxySelect: control.querySelector(PROXY_SELECT_SELECTOR),
      optionPresentationByValue: {},
      richDropdown: null,
      packagingSelect: null,
      quantityLockedByPackaging: false,
      quantityStep: 25,
      minRegularQty: 25,
      originalSelect: null,
      variants: parseJsonScript(control, '[data-quantity-tier-variants]') || [],
      optionNames: parseJsonScript(control, '[data-quantity-tier-option-names]') || [],
      stockMin: parseInteger(control.getAttribute('data-stock-min')) || 1,
      stockMax: parseInteger(control.getAttribute('data-stock-max')) || 3,
    };

    if (!instance.input || !instance.plusButton || !instance.minusButton) return null;

    if (mode === 'tier' && !instance.proxySelect) return null;

    return instance;
  }

  function initControl(control) {
    var existing = findInstanceByControl(control);
    if (existing) {
      if (existing.mode === 'tier') {
        refreshTierInstance(existing);
      } else {
        refreshStockInstance(existing);
      }
      return;
    }

    var instance = createInstance(control);
    if (!instance) return;

    instances.push(instance);

    if (instance.mode === 'tier') {
      refreshTierInstance(instance);
    } else {
      refreshStockInstance(instance);
    }
  }

  function initAll(root) {
    var searchRoot = root && root.querySelectorAll ? root : document;
    var controls = asArray(searchRoot.querySelectorAll(CONTROL_SELECTOR));
    controls.forEach(initControl);
  }

  function handleButtonClick(event) {
    var richOption = event.target && event.target.closest ? event.target.closest(RICH_OPTION_SELECTOR) : null;
    if (richOption) {
      var optionControl = richOption.closest(CONTROL_SELECTOR);
      var optionInstance = findInstanceByControl(optionControl);
      if (!optionInstance || !optionInstance.proxySelect) return;

      event.preventDefault();

      var optionValue = richOption.getAttribute('data-value');
      var optionIndex = asArray(optionInstance.proxySelect.options).findIndex(function (option) {
        return String(option.value) === String(optionValue);
      });

      if (optionIndex !== -1) {
        selectProxyIndex(optionInstance, optionIndex, true);
      }

      closeRichDropdown(optionInstance);
      return;
    }

    var richTrigger = event.target && event.target.closest ? event.target.closest(RICH_TRIGGER_SELECTOR) : null;
    if (richTrigger) {
      var triggerControl = richTrigger.closest(CONTROL_SELECTOR);
      var triggerInstance = findInstanceByControl(triggerControl);
      if (!triggerInstance) return;

      event.preventDefault();
      toggleRichDropdown(triggerInstance);
      return;
    }

    if (!event.target.closest || !event.target.closest(RICH_DROPDOWN_SELECTOR)) {
      closeAllRichDropdowns();
    }

    var button = event.target && event.target.closest ? event.target.closest('.qty-btn') : null;
    if (!button) return;

    var control = button.closest(CONTROL_SELECTOR);
    if (!control) return;

    var instance = findInstanceByControl(control);
    if (!instance) return;

    event.preventDefault();

    if (instance.mode === 'stock') {
      var currentStock = parseInteger(instance.input.value);
      if (currentStock === null) currentStock = instance.stockMin;
      var delta = button.classList.contains('plus') ? 1 : -1;
      instance.input.value = String(clampStockQuantity(instance, currentStock + delta));
      refreshStockInstance(instance);
      return;
    }

    if (!instance.proxySelect || !instance.proxySelect.options.length) return;

    if (instance.quantityLockedByPackaging) {
      syncInputFromProxy(instance);
      updateButtons(instance);
      return;
    }

    var step = Number.isFinite(instance.quantityStep) ? instance.quantityStep : 25;
    var minQty = Number.isFinite(instance.minRegularQty) ? instance.minRegularQty : step;
    var currentQty = parseInteger(instance.input.value);
    if (!Number.isFinite(currentQty)) {
      var selectedOption = instance.proxySelect.options[instance.proxySelect.selectedIndex];
      currentQty = parseQuantityFromOption(selectedOption);
    }

    var baseQty = Number.isFinite(currentQty) ? Math.max(minQty, currentQty) : minQty;
    var isPlus = button.classList.contains('plus');
    var targetQty = isPlus ? baseQty + step : Math.max(minQty, baseQty - step);
    var direction = isPlus ? 'up' : 'down';
    var targetIndex = findTierIndexForTarget(instance, targetQty, direction, minQty);

    if (targetIndex === -1) return;
    selectProxyIndex(instance, targetIndex, true);
  }

  function handleInput(event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches(QTY_INPUT_SELECTOR)) return;

    var control = input.closest(CONTROL_SELECTOR);
    if (!control) return;

    var instance = findInstanceByControl(control);
    if (!instance) return;

    sanitizeInputValue(input);

    if (instance.mode === 'stock') {
      refreshStockInstance(instance);
    }
  }

  function handleChange(event) {
    var target = event.target;
    if (!target || !target.matches) return;

    if (target.matches(PROXY_SELECT_SELECTOR)) {
      var selectControl = target.closest(CONTROL_SELECTOR);
      var selectInstance = findInstanceByControl(selectControl);
      if (selectInstance) {
        syncOriginalFromProxy(selectInstance);
      }
      return;
    }

    if (target.matches(QTY_INPUT_SELECTOR)) {
      var inputControl = target.closest(CONTROL_SELECTOR);
      var inputInstance = findInstanceByControl(inputControl);
      if (!inputInstance) return;

      if (inputInstance.mode === 'stock') {
        refreshStockInstance(inputInstance);
        return;
      }

      if (inputInstance.quantityLockedByPackaging) {
        syncInputFromProxy(inputInstance);
        updateButtons(inputInstance);
        return;
      }

      var enteredQty = parseInteger(target.value);
      if (enteredQty === null) {
        syncInputFromProxy(inputInstance);
        updateButtons(inputInstance);
        return;
      }

      var step = Number.isFinite(inputInstance.quantityStep) ? inputInstance.quantityStep : 25;
      var minQty = Number.isFinite(inputInstance.minRegularQty) ? inputInstance.minRegularQty : step;
      var normalizedQty = normalizeToStep(enteredQty, step, minQty);
      var normalizedIndex = findTierIndexForTarget(inputInstance, normalizedQty, 'up', minQty);

      if (normalizedIndex === -1) {
        syncInputFromProxy(inputInstance);
        updateButtons(inputInstance);
        return;
      }

      selectProxyIndex(inputInstance, normalizedIndex, true);
      return;
    }

    if (target.matches(OPTION_SELECT_SELECTOR)) {
      var formId = target.getAttribute('form') || '';
      var linkedInstance = findInstanceByFormId(formId);
      if (linkedInstance && linkedInstance.mode === 'tier' && target !== linkedInstance.proxySelect) {
        refreshTierInstance(linkedInstance);
        if (target.matches(PACKAGING_SELECT_SELECTOR) && isSampleDeckSelected(target)) {
          forceQuantityOneForSamplePackaging(linkedInstance);
        }
      }
    }
  }

  function handleBlur(event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches(QTY_INPUT_SELECTOR)) return;

    var control = target.closest(CONTROL_SELECTOR);
    if (!control) return;

    var instance = findInstanceByControl(control);
    if (!instance || instance.mode !== 'tier') return;

    if (instance.quantityLockedByPackaging) {
      syncInputFromProxy(instance);
      updateButtons(instance);
      return;
    }

    var enteredQty = parseInteger(target.value);
    if (enteredQty === null) {
      syncInputFromProxy(instance);
      updateButtons(instance);
      return;
    }

    var step = Number.isFinite(instance.quantityStep) ? instance.quantityStep : 25;
    var minQty = Number.isFinite(instance.minRegularQty) ? instance.minRegularQty : step;
    var normalizedQty = normalizeToStep(enteredQty, step, minQty);
    var normalizedIndex = findTierIndexForTarget(instance, normalizedQty, 'up', minQty);

    if (normalizedIndex === -1) {
      syncInputFromProxy(instance);
      updateButtons(instance);
      return;
    }

    selectProxyIndex(instance, normalizedIndex, true);
  }

  function handleKeydown(event) {
    if (event.key === 'Escape') {
      closeAllRichDropdowns();
    }
  }

  function subscribeToVariantChanges() {
    if (typeof window.subscribe !== 'function') return;
    if (!window.PUB_SUB_EVENTS || !window.PUB_SUB_EVENTS.variantChange) return;

    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
      cleanupInstances();
      instances.forEach(function (instance) {
        if (instance.mode === 'tier') {
          refreshTierInstance(instance);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('product-info:loaded', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('click', handleButtonClick);
  document.addEventListener('input', handleInput, true);
  document.addEventListener('change', handleChange, true);
  document.addEventListener('blur', handleBlur, true);
  document.addEventListener('keydown', handleKeydown, true);

  subscribeToVariantChanges();
})();
